<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer075">
<p class="CN ParaOverride-1" id="_idParaDest-1"> </p>
<p class="HT">LAST CHANCE TEXACO</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802188809.vue?b961dba2